import React from 'react';

export const ProgressLoader = () => {
  const width = 32;
  const height = 32;
  return (
    <svg viewBox="0 0 40 40" width={width} height={height} rotate="20deg">
      <defs>
        <clipPath id="prefix__clip-path">
          <circle className="prefix__cls-1" cx={-220} cy={21} r={12} />
        </clipPath>
        <clipPath id="prefix__clip-path-2">
          <circle className="prefix__cls-1" cx={-220} cy={9} r={2} />
        </clipPath>
        <clipPath id="prefix__clip-path-3">
          <circle className="prefix__cls-1" cx={-159.98} cy={21} r={12} />
        </clipPath>
        <clipPath id="prefix__clip-path-4">
          <path
            className="prefix__cls-1"
            d="M-146 21a14 14 0 00-14-14h-.13a2 2 0 00-2 2 2 2 0 002 2h.09a10 10 0 0110 10 2 2 0 002 2 2 2 0 002.04-2z"
          />
        </clipPath>
        <clipPath id="prefix__clip-path-5">
          <path
            className="prefix__cls-2"
            d="M-151.3 27.15l-1.33-6.81a1 1 0 01.79-1.18 1.05 1.05 0 01.5 0l7 2.24a1 1 0 01.65 1.26 1 1 0 01-.33.47l-5.66 4.58a1 1 0 01-1.4-.15 1.19 1.19 0 01-.22-.41z"
          />
        </clipPath>
        <clipPath id="prefix__clip-path-6">
          <circle className="prefix__cls-1" cx={-99.68} cy={21.22} r={12} />
        </clipPath>
        <clipPath id="prefix__clip-path-7">
          <path
            className="prefix__cls-1"
            d="M-99.68 35.22a14 14 0 0014-14 14 14 0 00-14-14h-.26a2 2 0 00-2 2 2 2 0 002 2h.18a10 10 0 0110 10 10 10 0 01-10 10 2 2 0 00-2 2 2 2 0 002.08 2z"
          />
        </clipPath>
        <clipPath id="prefix__clip-path-8">
          <path
            className="prefix__cls-2"
            d="M-106.26 30l6.73-1.44a1 1 0 011.19.77 1 1 0 010 .48l-1.84 6.65a1 1 0 01-1.24.7 1.1 1.1 0 01-.46-.28l-4.88-5.22a1 1 0 010-1.42 1.05 1.05 0 01.5-.24z"
          />
        </clipPath>
        <clipPath id="prefix__clip-path-9">
          <circle className="prefix__cls-1" cx={-39.52} cy={21.9} r={12} />
        </clipPath>
        <clipPath id="prefix__clip-path-10">
          <path
            className="prefix__cls-1"
            d="M-53.52 21.9a14 14 0 0014 14 14 14 0 0014-14 14 14 0 00-14-14h-.39a2 2 0 00-1.94 2 2 2 0 002.05 2h.28a10 10 0 0110 10 10 10 0 01-10 10 10 10 0 01-10-10 2 2 0 00-2-2 2 2 0 00-2 2z"
          />
        </clipPath>
        <clipPath id="prefix__clip-path-11">
          <path
            className="prefix__cls-2"
            d="M-47.67 14.9l1 6.87a1 1 0 01-.85 1.13 1.07 1.07 0 01-.47 0l-6.77-2.35a1 1 0 01-.61-1.27 1 1 0 01.33-.47l5.8-4.51a1 1 0 011.4.18.94.94 0 01.17.42z"
          />
        </clipPath>
        <clipPath id="prefix__clip-path-12">
          <path
            className="prefix__cls-1"
            d="M34.48 21.9a14.2 14.2 0 100 .37 2 2 0 00-4-.11 9.76 9.76 0 110-.26 2 2 0 004 0z"
          />
        </clipPath>
        <clipPath id="prefix__clip-path-13">
          <path className="prefix__cls-1" d="M-155.52-51.1h282v114h-282z" />
        </clipPath>
        <clipPath id="prefix__clip-path-14">
          <path className="prefix__cls-1" d="M4.48 5.9h32v32h-32z" />
        </clipPath>
        <clipPath id="prefix__clip-path-15">
          <path
            className="prefix__cls-2"
            d="M26.13 11.91l-6.53 1.87a1 1 0 01-1.24-.68.94.94 0 010-.5l1.48-6.43A1 1 0 0121 5.42a1.07 1.07 0 01.45.23l5 4.55a1 1 0 01.08 1.41 1.12 1.12 0 01-.4.3z"
          />
        </clipPath>
        <style>
          {
            '.prefix__cls-1,.prefix__cls-2{fill:none}.prefix__cls-2{clip-rule:evenodd}.prefix__cls-15{clip-path:url(#prefix__clip-path-13)}'
          }
        </style>
      </defs>
      <g id="prefix__Layer_5" data-name="Layer 5">
        <g clipPath="url(#prefix__clip-path-12)">
          <g clipPath="url(#prefix__clip-path-14)">
            <image
              width={32}
              height={32}
              transform="rotate(-90 21.19 16.71)"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAACA0lEQVRYR+3XTY7UMBDF8X+VnfR0SwiE2IzEBWDLHbgAHIyDwFVYcwDEEiSE5iOx32PhboYVs5ig2bQlL6KUlJ+fK44Sbz58No848r6C/z3OgDPgDDgDzoAz4NEB9b6CzUYtlIuJw1x5OhV2Nbmo+XDAp/cv7yv553gw4N3Hr7x9fcmr58mLHeynZA4zFygBGWOfIyAYkzheewMAwJcf18CeywM8u4BDMYcaTCWoGdQwCZQcqDih8DaA79cr3+YCzNxKPJngMAUXKeaEuQSlBFWQERRMJoRjG8BVFz+Xzq42oNIESxf7GuxqMHUzpZkTagaZQdFIYxNAdHG1dn4tyZQJJDKsNnuZuSRzgUUDUsPj4blRAu7iponrJqalkVEZCCMHTaIJppK0Y+PVNKmNegCbW5mbLuaeTE0UABIDvUA3dImWUEsyMVa/CcCGbnPbxFLETQsywDFePBlcQIbJIAtl0LfqAQMp0ZUsXdSM4xkQJMEpCRvEgHSbnhsBsMHQbJrGXGVqEyXKOHGIUxlK6AzINgDANt2wyjSJVUGGyd4pJMvx6AH+pOGtEggb5BGrzNo9ujxM6RBhHKdf0ACME8xGryGAYkDaMYkmUQJaJKUPzF0GRwQbJQCQ8t022FQH1dA87qX+BsD4EmwF8FhNGsBYRjIK00P0SNYuCskaoxnRaMzfAeIT7ZHlq9QAAAAASUVORK5CYII="
            />
          </g>
        </g>
        <g clipPath="url(#prefix__clip-path-15)">
          <path transform="rotate(-77 22.961 10.28)" fill="#3590ce" d="M13.66 1.31h18.6v17.94h-18.6z" />
        </g>
      </g>
    </svg>
  );
};
